export default "__VITE_ASSET__BM1wP5vO__"